import { h } from "hyperapp";

import regionLoadingCSS from "./region-loading.css";

const adjustAnimationDuration = ({ element }): void => {
  const {
    parentNode: { clientWidth },
  } = element;

  const animationDuration = (clientWidth * 10) / 50;

  element.style.animationDuration = `${animationDuration}s`;
};

export const regionLoading = ({ state: { on } }): JSX.Element => {
  return (
    <div
      class={on ? regionLoadingCSS.regionLoading : ""}
      oncreate={element => on && adjustAnimationDuration({ element })}
      onupdate={element => on && adjustAnimationDuration({ element })}
    />
  );
};
